"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Chat = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Chat = function Chat(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.154 14.492c.27 0 .484-.112.817-.396l1.735-1.484c-.345-.272-.653-.739-.653-1.625V6.648c0-1.903 1.244-3.056 3.263-3.056h4.627l-.006-.153c-.132-1.147-.95-1.939-2.49-1.939H2.509C.949 1.5 0 2.34 0 3.805v6.017c0 1.437.918 2.294 2.427 2.294h.092v1.708c0 .408.232.668.635.668zm9.143.008c.396 0 .635-.26.635-.668v-.836h.635c1.515 0 2.433-.863 2.433-2.299v-3.89c0-1.465-.95-2.304-2.515-2.304H8.53c-1.61 0-2.508.833-2.508 2.346v3.848c0 1.46.905 2.3 2.508 2.3h1.488l1.463 1.107c.326.284.54.396.817.396z",
    fill: "currentColor"
  }));
};

exports.Chat = Chat;
var _default = Chat;
exports.default = _default;